import React from "react"
import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import Button from "../../../../shared/components/atoms/button/button"
import decorationMobile from "../../../../assets/images/muestreo/decoration-mobile.svg"
import imageBacterium from "../../../../assets/images/muestreo/performance/image-bacterium.webp"

const StepTwo = props => {
  let {
    contenidoRedencion,
    randomKey,
    canRedeem,
    setActualStep,
    actualStep,
    myKey,
    setMyKey,
    servMessage,
    servOk,
    costRedeem,
    handleAquirePoints,
    availablePoints,
    ACTIVITY_ID_MUESTREO,
  } = props

  return (
    <div className="container rounded-top-no-mov">
      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-left rounded-top-left-no-mov hidden-mov-large background-color-primary" />
      ) : null}
      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-top-mov background-color-primary" />
      ) : null}
      <div
        className={
          "details rounded-top-no-mov activity-modal-style " +
          (["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO)
            ? "muestra-gratis-antibacterial container-step-background"
            : "muestreo-normal")
        }
      >
        <div className="details-step-three">
          {["91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
            <>
              <img
                className="image-baterium position-left"
                src={imageBacterium}
                alt="image-bacterium"
              />
              <img
                className="image-baterium position-right"
                src={imageBacterium}
                alt="image-bacterium"
              />
            </>
          ) : null}

          {documentToReactComponents(contenidoRedencion.json, {
            renderNode: {
              [BLOCKS.HEADING_1]: (node, children) => (
                <h1
                  key={randomKey}
                  className={
                    ACTIVITY_ID_MUESTREO == "91" || ACTIVITY_ID_MUESTREO == "92"
                      ? "text-color-primary"
                      : "text-color-secondary"
                  }
                >
                  {children}
                </h1>
              ),
              [BLOCKS.PARAGRAPH]: (node, children) => (
                <div key={JSON.stringify(node ? node : {})}>{children}</div>
              ),
            },
            renderMark: {
              [MARKS.UNDERLINE]: text => <u key={randomKey}>{text}</u>,
            },
            renderText: text => {
              if (/\%REDEEM\%/g.test(text)) {
                return (
                  <Button
                    onClick={e => {
                      if (canRedeem) {
                        const userInfo = JSON.parse(
                          localStorage.getItem("USER_INFO")
                        )
                        const updateSampling = JSON.parse(
                          localStorage.getItem("UPDATE_DATA_SAMPLE_PRODUCT")
                        )
                        let isReadySample =
                          userInfo &&
                          updateSampling &&
                          updateSampling.some(item => {
                            return item.email === userInfo.email &&  item.activityId === ACTIVITY_ID_MUESTREO
                          })



                        if (isReadySample) {
                          setActualStep(actualStep + 1)
                        } else {
                          setActualStep(5)
                        }
                      }
                    }}
                    disabled={!canRedeem}
                    className={`button${!canRedeem ? "-disabled" : ""} ${
                      // ["48", "91", "92", "137", "138", "141"].includes(
                      [
                        "48",
                        "91",
                        "92",
                        "137",
                        "138",
                        "143",
                        "192",
                        "194",
                      ].includes(ACTIVITY_ID_MUESTREO)
                        ? "background-color-primary-button"
                        : "background-color-tertiary"
                    }`}
                    title={
                      process.env.LOCALE === "es-CL"
                        ? "Canjear y participar"
                        : "Redimir y participar"
                    }
                  />
                )
              } else if (/\%SEND\%/g.test(text)) {
                return (
                  <form
                    key="myKeyForm"
                    id="myKey"
                    onSubmit={handleAquirePoints}
                  >
                    <input
                      id="myKeyInput"
                      key="myKeyInput"
                      type="text"
                      required
                      className="input-redention"
                      placeholder="- - - - - -"
                      value={myKey}
                      onChange={e => {
                        e.preventDefault()
                        e.persist()
                        setMyKey(s => e.target.value)
                      }}
                    />
                    {servMessage && (
                      <span className={`serv-message${servOk ? "" : "-error"}`}>
                        {servMessage}
                      </span>
                    )}
                    <Button
                      form="myKey"
                      type="submit"
                      className="button background-color-secondary"
                      title="Enviar"
                    />
                  </form>
                )
              } else if (/\%POINTS\%/g.test(text)) {
                return text.replace("%POINTS%", availablePoints)
              } else if (/\%COST\%/g.test(text)) {
                return (
                  <p
                    className={
                      ACTIVITY_ID_MUESTREO == "48" ||
                      ACTIVITY_ID_MUESTREO == "91" ||
                      ACTIVITY_ID_MUESTREO == "92"
                        ? "text-color-tertiary"
                        : ""
                    }
                  >
                    {text
                      .replace("%COST%", costRedeem)
                      .replace(
                        "%REDEEMTXT%",
                        process.env.LOCALE === "es-CL" ? "canjear" : "redimir"
                      )}
                  </p>
                )
              } else if (/en Nosotrasonline para participar/g.test(text)) {
                return (
                  <p
                    className={
                      ["48", "91", "192", "193"].includes(ACTIVITY_ID_MUESTREO)
                        ? "text-color-secondary"
                        : "text-color-tertiary"
                    }
                  >
                    {text}&nbsp;
                  </p>
                )
              } else {
                return (
                  <p
                    className={
                      ACTIVITY_ID_MUESTREO == "48" ||
                      ACTIVITY_ID_MUESTREO == "91" ||
                      ACTIVITY_ID_MUESTREO == "92"
                        ? "text-color-tertiary"
                        : ""
                    }
                  >
                    {text}&nbsp;
                  </p>
                )
              }
            },
          })}
        </div>
      </div>
      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-right rounded-top-right-no-mov hidden-mov-large background-color-primary" />
      ) : null}
    </div>
  )
}

export default StepTwo
